import styled from 'styled-components';
import Heading from '../Heading';
const H1 = styled(Heading).attrs({
  tagName: 'h1'
}).withConfig({
  displayName: "H1"
})([""]);
H1.displayName = 'H1';
export default H1;